import React from "react";
import { APPROVAL_STATUS } from "../../utils/agreementMapping";
import styles from "./agreementTracking.module.scss";

const RESULT_LABELS = {
  [APPROVAL_STATUS.APPROVED]: "Accepted",
  [APPROVAL_STATUS.REJECTED]: "Rejected",
};

// Accept / Reject buttons while pending; the outcome as static text after.
const ItemAction = ({ item, actions }) => {
  if (RESULT_LABELS[item.approvalStatus]) {
    return (
      <span className={styles.actionResult}>
        {RESULT_LABELS[item.approvalStatus]}
      </span>
    );
  }
  // Inactive items can't be actioned, so the buttons are greyed out.
  const disabled = !item.isActive || actions.respondingId === item.id;
  return (
    <div className={styles.actionButtons}>
      <button disabled={disabled} onClick={() => actions.accept(item)}>
        Accept
      </button>
      <button disabled={disabled} onClick={() => actions.startReject(item)}>
        Reject
      </button>
    </div>
  );
};

export default ItemAction;
